import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CommunityGalleryActions from 'actions/CommunityGalleryActions';
import ReportContentModalEN from 'components/GlobalModals/ReportContentModal/locales/ReportContentModal_en_US';
import ReportContentModalFR from 'components/GlobalModals/ReportContentModal/locales/ReportContentModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { toggleReportContentModal } = CommunityGalleryActions;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(ReportContentModalEN, ReportContentModalFR);

const fields = createSelector(
    createStructuredSelector({
        reportTitle: getTextFromResource(getText, 'reportTitle'),
        subTitle1: getTextFromResource(getText, 'subTitle1'),
        subTitle2: getTextFromResource(getText, 'subTitle2'),
        copied: getTextFromResource(getText, 'copied'),
        copy: getTextFromResource(getText, 'copy')
    }),
    localization => {
        return {
            localization
        };
    }
);

const functions = {
    toggleReportContentModal
};

const withReportContentModalProps = wrapHOC(connect(fields, functions));

export {
    withReportContentModalProps, fields, functions
};
